import styles from "./Compare.module.scss";
import classNames from "classnames/bind";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Grid, Lazy, FreeMode } from "swiper";
import {
    faBolt,
    faCarSide,
    faCircleInfo,
    faCirclePlus,
    faCircleXmark,
    faGears,
    faShieldHalved,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Brands from "~/Data/Brands";
import { Link } from "react-router-dom";
import { CarsInBrand } from "~/Data/CarsInBrand";
import { useEffect, useRef, useState } from "react";
import { handleHistoryView } from "~/hooks/function";
const cx = classNames.bind(styles);
function Compare({ data }) {
    console.log("cac");
    const [render, setRender] = useState([]);
    const [car, setCar] = useState();
    const select = document.getElementsByClassName(cx("car_select"));
    const chose = document.getElementsByClassName(cx("chose"));
    const box = document.getElementsByClassName(cx("box"));
    const icon = document.getElementsByClassName(cx("icon"));
    const submit = document.getElementsByClassName(cx("submit"));
    const wrapper = document.getElementsByClassName(cx("wrapper"));
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    const infoRef = useRef();
    useEffect(() => {
        box[0].classList.remove(cx("onresult"));
        wrapper[0].classList.remove(cx("ok"));
        box[0].classList.remove(cx("show"));
        icon[0].classList.remove(cx("active"));
        chose[0].style.display = "flex";
        submit[0].classList.add(cx("disable"));
        setCar(false);
    }, [box, wrapper, icon, chose, submit, data]);
    const handleResult = (e) => {
        box[0].classList.add(cx("onresult"));
        infoRef.current.scrollIntoView({
            block: "start",
        });
    };
    const handleClick = (brand) => {
        brand = brand.replace(" ", "");
        setRender(CarsInBrand[brand]);
    };
    const handleOff = () => {
        box[0].classList.remove(cx("show"));
        icon[0].classList.remove(cx("active"));
        wrapper[0].classList.remove(cx("ok"));
        box[0].classList.remove(cx("onresult"));
    };
    const handleShow = (e) => {
        box[0].classList.toggle(cx("show"));
        icon[0].classList.toggle(cx("active"));
        wrapper[0].classList.toggle(cx("ok"));
    };

    const handleDelete = () => {
        setCar("");
        submit[0].classList.add(cx("disable"));
        chose[0].style.display = "flex";
        box[0].classList.remove(cx("onresult"));
    };
    const handleChose = (item) => {
        submit[0].classList.remove(cx("disable"));
        select[0].classList.add(cx("hide"));
        chose[0].style.display = "none";
        setCar(item);
    };
    const handleOnChose = () => {
        select[0].classList.remove(cx("hide"));
    };
    return (
        <div className={cx("wrapper")}>
            <div onClick={handleOff} className={cx("overlay")}></div>
            <div className={cx("box")}>
                <div className={cx("car_wrapper")}>
                    <div className={cx("car")}>
                        <span className={cx("seeing")}>Đang xem</span>
                        <img alt="" src={data.avatar} />
                        <p>
                            {data.brand} {data.name}
                        </p>
                    </div>
                    <strong>
                        <i>VS</i>
                    </strong>
                    <div className={cx("car")}>
                        <div className={cx("chose")}>
                            <i onClick={handleOnChose}>
                                <FontAwesomeIcon icon={faCirclePlus} />
                            </i>
                            <span>Chọn xe muôn so sánh</span>
                        </div>
                        {car && (
                            <>
                                {" "}
                                <b onClick={handleDelete}>
                                    <FontAwesomeIcon icon={faCircleXmark} />
                                </b>
                                <img alt="" src={car.avatar} />
                                <p>
                                    {car.brand} {car.name}
                                </p>
                            </>
                        )}
                    </div>
                </div>

                <div className={cx("car_select", "hide")}>
                    <div className={cx("list_wrap")}>
                        <div className={cx("list")}>
                            <ul>
                                {Brands.map((brand, index) => {
                                    return (
                                        <li
                                            key={index}
                                            id={brand.brand.toLocaleLowerCase()}
                                            onClick={() =>
                                                handleClick(brand.brand)
                                            }
                                        >
                                            <p className={cx("list_item")}>
                                                <span>{brand.brand}</span>
                                                <img
                                                    src={brand.avatar}
                                                    alt={`Logo hãng siêu xe ${brand.brand}`}
                                                />
                                            </p>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className={cx("car_wrap")}>
                        <span>
                            Chọn xe để so sánh{" "}
                            <i onClick={() => handleOff()}>
                                <FontAwesomeIcon icon={faXmark} />
                            </i>
                        </span>
                        {!mediaQuery && (
                            <div className={cx("wrapper3")}>
                                <div className={cx("wrapper_swiper")}>
                                    <Swiper
                                        pagination={{
                                            dynamicBullets: true,
                                        }}
                                        lazy={true}
                                        grid={{
                                            rows: 2,
                                        }}
                                        freeMode={true}
                                        modules={[
                                            Grid,
                                            Lazy,
                                            Pagination,
                                            FreeMode,
                                        ]}
                                        breakpoints={{
                                            "@0.00": {
                                                slidesPerView: 2.4,
                                                slidesPerGroup: 2,
                                            },
                                        }}
                                        className={cx("swiper")}
                                    >
                                        {" "}
                                        {render &&
                                            render.map((item, index) => (
                                                <SwiperSlide
                                                    key={index}
                                                    onClick={() =>
                                                        handleChose(item)
                                                    }
                                                    className={cx(
                                                        "swiper_item"
                                                    )}
                                                >
                                                    <div
                                                        className={cx(
                                                            "swiper_item-link"
                                                        )}
                                                    >
                                                        <img
                                                            className={cx(
                                                                "swiper-lazy"
                                                            )}
                                                            loading="lazy"
                                                            src={item.avatar}
                                                            alt={item.name}
                                                        />

                                                        <h4>{item.name}</h4>
                                                        <div
                                                            className={cx(
                                                                "car_info"
                                                            )}
                                                        ></div>
                                                    </div>
                                                </SwiperSlide>
                                            ))}
                                    </Swiper>
                                </div>
                            </div>
                        )}
                        {mediaQuery &&
                            render &&
                            render.map((item, index) => (
                                <div
                                    onClick={() => handleChose(item)}
                                    key={index}
                                    className={cx("car_item")}
                                >
                                    <img alt="" src={item.avatar} />
                                    <p>{item.name}</p>
                                </div>
                            ))}
                    </div>
                </div>
                <div className={cx("result")}>
                    {" "}
                    <div>
                        <h5 ref={infoRef}>
                            <i>
                                {" "}
                                <FontAwesomeIcon icon={faCircleInfo} />
                            </i>
                            Thông tin
                        </h5>
                        <div>
                            <p>Tên xe</p>
                            <p>{data.name}</p>
                        </div>
                        <div>
                            <p>Hãng</p>
                            <p>{data.brand}</p>
                        </div>
                        <div>
                            <p>Giá công bố</p>
                            <p>{data.price} Tỷ</p>
                        </div>
                        <h5>
                            {" "}
                            <i>
                                {" "}
                                <FontAwesomeIcon icon={faCarSide} />
                            </i>{" "}
                            Thiết kế - Trang bị
                        </h5>
                        <div>
                            <p>Kiểu dáng</p>
                            <p>{data.type}</p>
                        </div>
                        <div>
                            <p>Số chỗ ngồi</p>
                            <p> {data.para.sit} chỗ</p>
                        </div>
                        <div>
                            <p>Kích thước</p>
                            <p> {data.para.size} mm</p>
                        </div>
                        <div>
                            <p>Chiều dài cơ sở</p>
                            <p> {data.para.long} mm</p>
                        </div>
                        <div>
                            <p>Cỡ mâm</p>
                            <p> {data.para.mam} inch</p>
                        </div>
                        <h5>
                            <i>
                                {" "}
                                <FontAwesomeIcon icon={faGears} />
                            </i>{" "}
                            Động cơ - Hộp số
                        </h5>
                        <div>
                            <p>Động cơ</p>
                            <p>{data.engine}</p>
                        </div>{" "}
                        <div>
                            <p>Công suất</p>
                            <p> {data.para.watt}</p>
                        </div>{" "}
                        <div>
                            <p>Mo-men xoắn</p>
                            <p> {data.para.momem}</p>
                        </div>
                        <div>
                            <p>Hộp số</p>
                            <p> {data.para.hopso}</p>
                        </div>
                        <div>
                            <p>Tỷ lệ nén</p>
                            <p> {data.para.tilenen}</p>
                        </div>
                        <div>
                            <p>Hệ dẫn động</p>
                            <p>{data.para.dandong}</p>
                        </div>
                        <h5>
                            {" "}
                            <i>
                                {" "}
                                <FontAwesomeIcon icon={faBolt} />
                            </i>{" "}
                            Tốc độ
                        </h5>
                        <div>
                            <p>Tốc độ tối đa</p>
                            <p> {data.max} Km/h</p>
                        </div>{" "}
                        <div>
                            <p>Tốc độ 0 - 100 Km/h</p>
                            <p>{data.para.max100} giây</p>
                        </div>{" "}
                        <div>
                            <p>Tốc độ 0 - 200 Km/h</p>
                            <p> {data.para.max200} giây</p>
                        </div>
                        <h5>
                            {" "}
                            <i>
                                {" "}
                                <FontAwesomeIcon icon={faShieldHalved} />
                            </i>{" "}
                            Tính năng - An toàn
                        </h5>
                        <div>
                            <p>Tốc độ 0 - 200 Km/h</p>
                            <p>5</p>
                        </div>{" "}
                        <div>
                            <p>Tốc độ 0 - 200 Km/h</p>
                            <p>5</p>
                        </div>
                        <div>
                            <p>Tốc độ 0 - 200 Km/h</p>
                            <p>5</p>
                        </div>
                    </div>
                    {car && (
                        <div>
                            <h5>&nbsp;</h5>
                            <div>
                                <p>&nbsp;</p>
                                <p>{car.name}</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p>{car.brand}</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p>{car.price} Tỷ</p>
                            </div>
                            <h5>&nbsp;</h5>
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.type}</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.para.sit} chỗ</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.para.size} mm</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.para.long} mm</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.para.mam} inch</p>
                            </div>
                            <h5>&nbsp;</h5>
                            <div>
                                <p>&nbsp;</p>
                                <p>{car.engine}</p>
                            </div>{" "}
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.para.watt}</p>
                            </div>{" "}
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.para.momem}</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.para.hopso}</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p>{car.para.tilenen}</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p>{car.para.dandong}</p>
                            </div>
                            <h5>&nbsp;</h5>
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.max} Km/h</p>
                            </div>{" "}
                            <div>
                                <p>&nbsp;</p>
                                <p>{car.para.max100} giây</p>
                            </div>{" "}
                            <div>
                                <p>&nbsp;</p>
                                <p> {car.para.max200} giây</p>
                            </div>
                            <h5>&nbsp;</h5>
                            <div>
                                <p>&nbsp;</p>
                                <p>5</p>
                            </div>{" "}
                            <div>
                                <p>&nbsp;</p>
                                <p>5</p>
                            </div>
                            <div>
                                <p>&nbsp;</p>
                                <p>5</p>
                            </div>
                            {car.name !== data.name && (
                                <p
                                    className={cx("seethis")}
                                    onClick={() => handleHistoryView(car)}
                                >
                                    <Link to={car.link}>
                                        <p>
                                            {car.brand} {car.name}
                                        </p>
                                    </Link>
                                </p>
                            )}
                        </div>
                    )}
                </div>
                <p onClick={handleResult} className={cx("submit", "disable")}>
                    So sánh
                </p>
            </div>
            <i onClick={handleShow} className={cx("icon")}>
                {/* <FontAwesomeIcon icon={faCarBurst} /> */}
                Vs
            </i>
        </div>
    );
}
export default Compare;
